var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dataset 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Default"
  }, /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M34.0002 9.31864V9.32206V27.9766C34.0002 30.3233 32.1444 32.2273 30.0204 32.2273H12.138C10.0111 32.2273 8.1582 30.3264 8.1582 27.9766V4.75082C8.1582 2.401 10.0111 0.500098 12.138 0.500098L25.7098 0.500112L25.7137 0.500083C26.4916 0.494092 27.2464 0.81418 27.8118 1.40078C27.8123 1.40136 27.8129 1.40194 27.8135 1.40252L33.1375 7.04849C33.138 7.04911 33.1386 7.04972 33.1392 7.05034C33.6936 7.65133 34.0061 8.46627 34.0002 9.31864Z",
    fill: "#F2F2F2",
    stroke: "url(#paint0_linear_4559_11351)"
  }), /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M30.4201 12.9551V12.9585V31.613C30.4201 33.9598 28.5643 35.8637 26.4403 35.8637H8.55794C6.43106 35.8637 4.57812 33.9628 4.57812 31.613V8.38729C4.57812 6.03747 6.43106 4.13657 8.55794 4.13657L22.1298 4.13659L22.1336 4.13656C22.9115 4.13057 23.6663 4.45065 24.2317 5.03726C24.2323 5.03784 24.2328 5.03842 24.2334 5.03899L29.5574 10.685C29.558 10.6856 29.5585 10.6862 29.5591 10.6868C30.1135 11.2878 30.426 12.1027 30.4201 12.9551Z",
    fill: "#F2F2F2",
    stroke: "url(#paint1_linear_4559_11351)"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M26.842 16.5913V16.5948V35.2493C26.842 37.596 24.9862 39.5 22.8622 39.5H4.97981C2.85294 39.5 1 37.5991 1 35.2493V12.0235C1 9.6737 2.85294 7.7728 4.97981 7.7728L18.5516 7.77282L18.5555 7.77279C19.3334 7.7668 20.0882 8.08689 20.6536 8.67349C20.6541 8.67407 20.6547 8.67465 20.6553 8.67522L25.9793 14.3212C25.9798 14.3218 25.9804 14.3224 25.981 14.323C26.5354 14.924 26.8479 15.739 26.842 16.5913Z",
    fill: "#F2F2F2",
    stroke: "url(#paint2_linear_4559_11351)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4559_11351",
    x1: 21.0793,
    y1: 0,
    x2: 21.0793,
    y2: 32.7273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACCAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4559_11351",
    x1: 17.4992,
    y1: 3.63647,
    x2: 17.4992,
    y2: 36.3637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D97FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA5CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4559_11351",
    x1: 13.9211,
    y1: 7.27271,
    x2: 13.9211,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D6EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B929FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file_upload.7c5c140f4e0eb259d937c7613be28bc3.svg";
export { ForwardRef as ReactComponent };